import { Injectable } from '@angular/core';

import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  filter,
  map,
  Observable,
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MediaDevicesService {
  private isInited$ = new BehaviorSubject<boolean>(false);
  private initInProgress = false;
  private initVideoError$ = new BehaviorSubject<string>(undefined);
  private videoDevices$ = new BehaviorSubject<Array<MediaDeviceInfo>>([]);

  selectVideoDevicesState(): Observable<{
    isInited: boolean;
    error: string;
    devices: Array<MediaDeviceInfo>;
  }> {
    if (!this.isInited$.value && !this.initInProgress) {
      this.initVideoDevice().subscribe({
        next: r => {
          this.isInited$.next(true);
          this.videoDevices$.next(r);
          this.initVideoError$.next(undefined);
        },
        error: e => {
          this.videoDevices$.next([]);
          this.initVideoError$.next(e);
          this.isInited$.next(true);
        },
      });
    }
    return combineLatest([
      this.isInited$.asObservable(),
      this.videoDevices$.asObservable(),
      this.initVideoError$.asObservable(),
    ]).pipe(
      filter(([isInited]) => isInited),
      debounceTime(0),
      map(([isInited, devices, error]) => ({ devices, isInited, error })),
    );
  }

  // can be inited again from component
  public initVideoDevice(): Observable<Array<MediaDeviceInfo>> {
    this.isInited$.next(false);
    this.initInProgress = true;
    return new Observable(obs => {
      if (
        'mediaDevices' in navigator &&
        'getUserMedia' in navigator.mediaDevices
      ) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then(() => {
            navigator.mediaDevices
              .enumerateDevices()
              .then(r => {
                const devices = r
                  .filter(i => i.kind === 'videoinput')
                  .filter(i => i.deviceId); // filter by device id neew for ngx-webcam
                this.isInited$.next(true);
                this.initInProgress = false;
                const res = devices;
                // mock
                // if (!environment.production) {
                // 	res = [...devices, devices[0]]
                // }
                this.videoDevices$.next(res);
                obs.next(res);
              })
              .catch(err => {
                this.isInited$.next(true);
                this.initInProgress = false;
                this.initVideoError$.next(
                  'Some Error for enumerate video device',
                );
                console.error(err);
                obs.error('Some Error for enumerate video device');
              });
          })
          .catch(err => {
            this.isInited$.next(true);
            this.initInProgress = false;
            console.error(err);
            this.initVideoError$.next('Some Error for get video devices');
            obs.error('Some Error for get video devices');
          });
      } else {
        this.isInited$.next(true);
        this.initInProgress = false;
        console.error('Cameras Are not Available');
        obs.error('Cameras Are not Available');
      }
    });
  }
}
